import React from 'react';
import { Button } from '@acpaas-ui/react-components';
import { DESC_SIGN } from '../../constants/table.constants';

const TableSortButton = ({ label, value, sort, type = '', onChange }) => {
  const handleChange = () => onChange({ sort: sort === value ? `-${value}` : value });
  const parsedSort = sort.replace(value, '');
  const isSortActive = sort.replace('-', '') === value;
  const sortText = isSortActive ? (sort?.[0] === DESC_SIGN ? 'Sorteer oplopend' : 'Sorteer aflopend') : 'Sorteer';
  return (
    <Button
      className="a-table__header-button a-button--transparent"
      onClick={handleChange}
      iconRight={parsedSort === DESC_SIGN ? 'ai-arrow-down-1' : parsedSort === '' ? 'ai-arrow-up-1' : ''}
      title={sortText}
      type={type}
      size="tiny"
    >
      {label}
      <span className="u-screen-reader-only">{sortText}</span>
    </Button>
  );
};
export default TableSortButton;
